import { getTimeLeftLabel } from '@griply/utils';
import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlagFilled } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { useToday } from 'shared/contexts/today';
import { useI18nLocale } from 'shared/lib/react-i18next/use-i18n-locale';
import { Timestamp } from 'shared/types/timestamp';

import * as Styled from './deadline-chip.style';

const FLAG_ICON_SIZE = 9;
const COMPLETED_FLAG_ICON_SIZE = 12;

export type DeadlineChipProps = {
  date: Timestamp;
  isShort?: boolean;
  isMidShort?: boolean;
  isCompleted?: boolean;
};

export const DeadlineChip: React.FC<DeadlineChipProps> = ({
  date,
  isShort,
  isMidShort,
  isCompleted,
}) => {
  const today = useToday();
  const { t } = useTranslation();
  const language = useI18nLocale();

  const { label, isOverdue, isLastWeek } = getTimeLeftLabel(date, {
    today,
    t,
    language,
    short: isShort,
    midShort: isMidShort,
    isCompleted,
  });

  return (
    <Styled.Container
      $overdue={isOverdue}
      $lastWeek={isLastWeek}
      $isCompleted={isCompleted}
    >
      <Icon
        icon={FlagFilled}
        size={isCompleted ? COMPLETED_FLAG_ICON_SIZE : FLAG_ICON_SIZE}
      />
      <Typography variant="caption">{label}</Typography>
    </Styled.Container>
  );
};
